import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=042631a0"
var script = {}
import style0 from "./theme.vue?vue&type=style&index=0&id=042631a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports